import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Navigation from '../Navigation'
import ThankyouPage from '../ThankYou'
import SubscribePage from '../Subscribe'
import SubscribePage2 from '../Subscribe2'
import SubscribePage3 from '../Subscribe3'
import SubscribePage4 from '../Subscribe4'
import SubscribePage5 from '../Subscribe5'
import SubscribePage6 from '../Subscribe6'
import SubscribePage7 from '../Subscribe7'
import SubscribePage8 from '../Subscribe8'
import SignUpPage from '../SignUp'
import SignInPage from '../SignIn'
import PasswordForgetPage from '../PasswordForget'
import PasswordChangePage from '../PasswordChange'
import EmailChangePage from '../EmailChange'

// import HomePage from '../Home';
import PaymentPage from '../Payment'
import AccountPage from '../Account'
import AccountPaymentPage from '../AccountPayment'
import PageNotFound from '../404'

import * as ROUTES from '../../constants/routes'
import { withAuthentication } from '../Session'

import BgImage from '../../imgs/Bakgrund-checkout.jpg'

import { useTranslation } from "react-i18next"

const App = (props) => {
  const { i18n } = useTranslation()
  const [baseUrl, setBaseUrl] = useState(i18n.language === 'sv' ? '' : '/' + i18n.language);

  useEffect(() => {
    setBaseUrl(i18n.language === 'sv' ? '' : '/' + i18n.language)
  }, [i18n.language])

  let loginClass = 'rootContainer'
  const BgImageObj = {}
  BgImageObj.backgroundImage = 'linear-gradient(180deg, #F2A1B0 0%, #FDECF4 77%)' // 'url(' + BgImage + ')'

  // check here current page is being visited via loggedIn users
  const currentUser = props.firebase.auth.currentUser
  if (currentUser) {
    loginClass += ' loggedIn '
  }

  if (window.location.pathname === '/' || window.location.pathname === '/en') {
    loginClass += ' homepage'
  } else {
    let pageName = window.location.pathname.substring(1)
    if (pageName.includes('en/')) pageName = pageName.substring(3)
    loginClass += ' ' + pageName + '-page'
  }


  return (
    <BrowserRouter>
      <div className={loginClass} style={{ ...BgImageObj }}>
        <Navigation />
        <Routes>
          {/* <hr /> */}
          <Route path={baseUrl + ROUTES.THANKYOU} element={<ThankyouPage />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE} element={<SubscribePage />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE2} element={<SubscribePage2 />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE3} element={<SubscribePage3 />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE4} element={<SubscribePage4 />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE5} element={<SubscribePage5 />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE6} element={<SubscribePage6 />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE7} element={<SubscribePage7 />} />
          <Route path={baseUrl + ROUTES.SUBSCRIBE8} element={<SubscribePage8 />} />
          <Route path={baseUrl + ROUTES.SIGN_IN} element={<SignInPage />} />
          <Route path={baseUrl + '/'} element={<SignInPage />} />
          <Route path={baseUrl + ROUTES.SIGN_UP} element={<SignUpPage />} />
          <Route path={baseUrl + ROUTES.PASSWORD_FORGET} element={<PasswordForgetPage />} />
          <Route path={baseUrl + ROUTES.PASSWORD_CHANGE} element={<PasswordChangePage />} />
          <Route path={baseUrl + ROUTES.EMAIL_CHANGE} element={<EmailChangePage />} />

          {/* <Route path={baseUrl + ROUTES.HOME} element={<HomePage />} /> */}
          <Route path={baseUrl + ROUTES.PAYMENT} element={<PaymentPage />} />
          <Route path={baseUrl + ROUTES.ACCOUNT} element={<AccountPage />} />
          <Route path={baseUrl + ROUTES.ACCOUNT_PAYMENT} element={<AccountPaymentPage />} />


          {/* redirect to 404 page  */}
          <Route path={baseUrl + ROUTES.NOTFOUND} element={<PageNotFound />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  )

}

export default withAuthentication(App)
